var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 587",
    style: {
      fill: "#008da9",
      stroke: "#008da9"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h24v3H0z",
    transform: "translate(0 19)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h23v2H.5z",
    transform: "translate(0 19)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 588",
    style: {
      fill: "#008da9",
      stroke: "#008da9"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h24v17H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h23v16H.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.af3ba1215bc514fd95081eaba274fca1.svg";
export { ForwardRef as ReactComponent };